// deps
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { StyleSheet, css } from "aphrodite";

// components
import Portal from "../Portal";

// contexts
import { HighlightOverlayProvider } from "./Context";

const styles = StyleSheet.create({
  overlay__highlighted: {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, .25)",
  },
  wrapper: {
    position: "fixed",
    maxHeight: "calc(100vh - 2rem)",
    bottom: "0.5rem",
    left: "0.5rem",
    right: "0.5rem",
    backgroundColor: "#ffffff",
    zIndex: 1,
    padding: "1rem",
    borderRadius: "0.25rem",
    overflow: "auto",
    boxShadow: "0 0 1.25rem #3a485f",
  },
});

function HighlightOverlay(props) {
  const { initialHighlighted = false, children } = props;

  const [highlighted, setHighlighted] = useState(initialHighlighted);

  const $overlay = useRef();

  useEffect(
    function () {
      if (highlighted) {
        window.document.querySelector("body").style.overflow = "hidden";
      } else {
        window.document.querySelector("body").style.overflow = null;
      }
      return function () {
        window.document.querySelector("body").style.overflow = null;
      };
    },
    [highlighted]
  );

  return (
    <HighlightOverlayProvider
      highlighted={highlighted}
      setHighlighted={setHighlighted}
      overlayRef={$overlay}
    >
      <Portal selector="body">
        <div
          className={css(highlighted && styles.overlay__highlighted)}
          ref={$overlay}
        >
          <div className={css(styles.wrapper)}>{children}</div>
        </div>
      </Portal>
    </HighlightOverlayProvider>
  );
}

HighlightOverlay.propTypes = {
  initialHighlighted: PropTypes.bool,
  children: PropTypes.node,
};

export default HighlightOverlay;

export { HighlightOverlayProvider, useHighlightOverlay } from "./Context";
